var map = {
	"./events/food_balcony.jpeg": 91173,
	"./events/wedding.jpeg": 6704,
	"./events/wedding_dinner.jpeg": 49907,
	"./hotel/background.jpeg": 51441,
	"./hotel/balcony.jpeg": 39373,
	"./hotel/banner_desktop.jpg": 41941,
	"./hotel/banner_desktop_no_logo.jpeg": 38172,
	"./hotel/banner_mobile.jpg": 19305,
	"./hotel/bath_room1.jpeg": 2093,
	"./hotel/bath_room2.jpeg": 93836,
	"./hotel/bathroom.jpeg": 15671,
	"./hotel/bathroom2.jpeg": 17781,
	"./hotel/bathroom3.jpg": 91711,
	"./hotel/beach.jpeg": 34234,
	"./hotel/bg-masthead2.jpg": 36893,
	"./hotel/diving.jpg": 96397,
	"./hotel/entrance.png": 55876,
	"./hotel/frontside.jpeg": 55085,
	"./hotel/frontside2.jpg": 19784,
	"./hotel/hotel.jpg": 7720,
	"./hotel/inside.jpg": 67878,
	"./hotel/inside_day.jpeg": 69464,
	"./hotel/inside_day2.jpeg": 72112,
	"./hotel/inside_sunset.jpeg": 58538,
	"./hotel/inside_xmas.jpeg": 51411,
	"./hotel/pool_closeup.jpeg": 87277,
	"./hotel/pool_day.jpeg": 90390,
	"./hotel/pool_day2.jpeg": 12118,
	"./hotel/pool_day_2.jpeg": 89147,
	"./hotel/pool_day_2_2.jpeg": 18314,
	"./hotel/pool_night.jpeg": 9786,
	"./hotel/sailboat.jpg": 35847,
	"./hotel/scroll_horizontal.png": 58816,
	"./hotel/sunset1.jpg": 18217,
	"./hotel/sunset2.jpg": 16778,
	"./hotel/sunset3.jpg": 19667,
	"./hotel/veranda_day1.jpeg": 99610,
	"./hotel/veranda_day1_2.jpeg": 6903,
	"./hotel/veranda_day2.jpeg": 38791,
	"./hotel/veranda_day3.jpeg": 53252,
	"./hotel/veranda_day4.jpeg": 73233,
	"./hotel/veranda_day5.jpeg": 9798,
	"./hotel/veranda_day_6.jpeg": 43684,
	"./hotel/veranda_sunset.jpeg": 98317,
	"./hotel/veranda_sunset2.jpeg": 96075,
	"./insurance/img.png": 97209,
	"./logo/leaflogo.png": 47276,
	"./logo/logo.svg": 36064,
	"./logo/logo_black.png": 76148,
	"./logo/logo_new.png": 24055,
	"./logo/logo_text.svg": 98864,
	"./logo/logo_white.png": 51802,
	"./logo/logo_with_text.svg": 19819,
	"./logo/logo_with_text_below.svg": 70421,
	"./logo/logo_with_text_white_background.svg": 43594,
	"./logo/logo_with_white_background.svg": 76720,
	"./logo/logoblack.png": 205,
	"./logo/logowhite.png": 21587,
	"./logo/navlogo.png": 50881,
	"./logo/wordlogo2.png": 65670,
	"./new/DSCF3564.jpg": 81040,
	"./new/DSCF3565.jpg": 38001,
	"./new/DSCF3570.jpg": 38959,
	"./new/DSCF3576.jpg": 33505,
	"./new/DSCF3589.jpg": 36191,
	"./new/DSCF3598.jpg": 11009,
	"./new/DSCF3600.jpg": 21533,
	"./new/DSCF3603.jpg": 85038,
	"./new/DSCF3604.jpg": 17657,
	"./new/DSCF3605.jpg": 52504,
	"./new/DSCF3615.jpg": 90895,
	"./new/DSCF3623.jpg": 79988,
	"./new/DSCF3632.jpg": 67190,
	"./new/DSCF3642.jpg": 90955,
	"./new/DSCF3652.jpg": 20756,
	"./new/DSCF3653.jpg": 99061,
	"./new/DSCF3659.jpg": 45495,
	"./new/DSCF3669.jpg": 72994,
	"./new/DSCF3673.jpg": 76435,
	"./new/DSCF3689.jpg": 79644,
	"./new/DSCF3693.jpg": 81545,
	"./new/DSCF3695.jpg": 56887,
	"./new/balcony.jpg": 9658,
	"./new/drone_pool.jpg": 57749,
	"./new/drone_pool2.jpg": 68741,
	"./new/drone_sea_view.jpg": 5672,
	"./new/drone_sea_view2.jpg": 62626,
	"./new/entrance.jpg": 7400,
	"./new/entrance2.jpg": 43298,
	"./new/palms.jpg": 63017,
	"./new/pool.jpg": 32504,
	"./new/pool10.jpg": 16019,
	"./new/pool11.jpg": 13130,
	"./new/pool2.jpg": 52946,
	"./new/pool3.jpg": 93883,
	"./new/pool4.jpg": 83796,
	"./new/pool5.jpg": 78453,
	"./new/pool6.jpg": 48134,
	"./new/pool7.jpg": 58847,
	"./new/pool8.jpg": 94088,
	"./new/pool9.jpg": 64361,
	"./new/pool_reading_book.jpg": 87163,
	"./new/pool_relaxing.jpg": 12297,
	"./new/pool_sea_view.jpg": 70268,
	"./new/reception.png": 68389,
	"./new/room_sea_view.jpg": 23937,
	"./new/room_sea_view2.jpg": 45081,
	"./new/room_sea_view3.jpg": 79832,
	"./new/room_sea_view4.jpg": 72903,
	"./new/room_sea_view_balcony.jpg": 78924,
	"./new/room_sea_view_balcony2.jpg": 12462,
	"./new/sea_view_day.jpg": 40506,
	"./new/sea_view_sunset.jpg": 52742,
	"./new/sunny_sea_view.jpg": 97221,
	"./new/sunny_sea_view_small.jpg": 16429,
	"./resturant/1.jpg": 47847,
	"./resturant/2.jpg": 56988,
	"./resturant/all_day_menu_1.png": 52258,
	"./resturant/all_day_meny_2.png": 93817,
	"./resturant/breakfast_menu_1.png": 37429,
	"./resturant/breakfast_menu_2.png": 83866,
	"./resturant/starters_menu.png": 23308,
	"./rooms/IMG_0927.jpg": 48616,
	"./rooms/IMG_1052.jpg": 39026,
	"./rooms/bathroom.jpg": 71518,
	"./rooms/bathroom2.jpg": 42200,
	"./rooms/bathroom3.jpg": 7353,
	"./rooms/bathroom4.jpg": 74734,
	"./rooms/bathroom5.jpg": 78823,
	"./rooms/garden_view_ocean_suite/DSC00407.jpg": 76295,
	"./rooms/garden_view_ocean_suite/DSC00417.jpg": 41772,
	"./rooms/mountain_view_king/bathroom.jpeg": 30711,
	"./rooms/mountain_view_king/bed.jpeg": 30786,
	"./rooms/mountain_view_king/desk.jpeg": 32524,
	"./rooms/mountain_view_king/lounge.jpeg": 49911,
	"./rooms/mountain_view_queen/IMG_0941.jpg": 38627,
	"./rooms/mountain_view_queen/IMG_0964.jpg": 49720,
	"./rooms/mountain_view_queen/IMG_0972.jpg": 12109,
	"./rooms/mountain_view_queen/IMG_0977.jpg": 53352,
	"./rooms/ocean_view_king/IMG_1151.jpeg": 44202,
	"./rooms/ocean_view_king/IMG_1153.jpeg": 12276,
	"./rooms/ocean_view_king/IMG_1159.jpeg": 58418,
	"./rooms/ocean_view_king/IMG_1160.jpeg": 42734,
	"./rooms/ocean_view_king/IMG_1161.jpeg": 89913,
	"./rooms/ocean_view_king/IMG_1162.jpeg": 52200,
	"./rooms/ocean_view_king/IMG_1164.jpeg": 44994,
	"./rooms/ocean_view_loft_suite/PHOTO-2023-03-17-10-28-19.jpg": 48287,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_1.jpeg": 59843,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_2.jpeg": 48406,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_3.jpeg": 34785,
	"./rooms/ocean_view_loft_suite/ocean_view_loft_4.jpeg": 12148,
	"./rooms/ocean_view_queen/IMG_0842.jpeg": 30833,
	"./rooms/ocean_view_queen/IMG_0854.jpeg": 98090,
	"./rooms/ocean_view_queen/IMG_0862.jpeg": 85087,
	"./rooms/ocean_view_queen/IMG_0875.jpeg": 40143,
	"./rooms/ocean_view_queen/IMG_0883.jpeg": 37034,
	"./rooms/ocean_view_queen/IMG_0895.jpeg": 38673,
	"./rooms/ocean_view_queen/IMG_0900.jpeg": 9220,
	"./rooms/ocean_view_queen/IMG_0909.jpeg": 8911,
	"./rooms/ocean_view_queen/IMG_0920.jpeg": 38082,
	"./rooms/ocean_view_queen/IMG_0921.jpeg": 30189,
	"./rooms/ocean_view_queen/IMG_0925.jpeg": 73561,
	"./rooms/ocean_view_queen/IMG_0927.jpeg": 18907,
	"./rooms/ocean_view_queen/IMG_0931.jpeg": 74652,
	"./rooms/ocean_view_queen/IMG_0937.jpeg": 45790,
	"./rooms/ocean_view_queen/IMG_1006.jpeg": 70296,
	"./rooms/ocean_view_queen/IMG_1022.jpeg": 81866,
	"./rooms/ocean_view_queen/IMG_1032.jpeg": 81467,
	"./rooms/ocean_view_suite/bathroom.jpeg": 63915,
	"./rooms/ocean_view_suite/bathroom.jpg": 89800,
	"./rooms/ocean_view_suite/bathroom_view.jpg": 26528,
	"./rooms/ocean_view_suite/bed.jpeg": 36574,
	"./rooms/ocean_view_suite/bed2.jpeg": 74382,
	"./rooms/ocean_view_suite/bed2.jpg": 51203,
	"./rooms/ocean_view_suite/bed4.jpg": 66653,
	"./rooms/ocean_view_suite/living_area.jpg": 96407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35041;